/*******************************************************************************
Close A Modal Window
*******************************************************************************/

export default function closeModalWindow() {

    $('body').removeClass('hide-overflow');
    $('.modal-background').remove();

}
